/**
 * Bulb colors as they actually read at night, not CSS names.
 * Warm white is an amber around 2400K, which is why a mockup using #FFFFFF
 * always looks wrong next to a real photo.
 */
export const BULB_COLORS = {
  warmWhite: '#FFB55A',
  pureWhite: '#FFF4E2',
  coolWhite: '#DCEBFF',
  red: '#FF3320',
  green: '#2BE04B',
  blue: '#3C7BFF',
  amber: '#FFA317',
  pink: '#FF5FA8',
  purple: '#9B5CFF',
  teal: '#31E3C7',
} as const

export interface PalettePreset {
  id: string
  label: string
  colors: string[]
  patternRepeat: number
}

/** The colors this trade actually installs, which is a short list. */
export const PALETTE_PRESETS: PalettePreset[] = [
  { id: 'warm', label: 'Warm white', colors: [BULB_COLORS.warmWhite], patternRepeat: 1 },
  { id: 'pure', label: 'Pure white', colors: [BULB_COLORS.pureWhite], patternRepeat: 1 },
  { id: 'cool', label: 'Cool white', colors: [BULB_COLORS.coolWhite], patternRepeat: 1 },
  { id: 'red', label: 'Red', colors: [BULB_COLORS.red], patternRepeat: 1 },
  { id: 'green', label: 'Green', colors: [BULB_COLORS.green], patternRepeat: 1 },
  { id: 'blue', label: 'Blue', colors: [BULB_COLORS.blue], patternRepeat: 1 },
  {
    id: 'multi',
    // One word, so it fits its tile without being cut to Multico...
    label: 'Multi',
    colors: [
      BULB_COLORS.red,
      BULB_COLORS.green,
      BULB_COLORS.blue,
      BULB_COLORS.amber,
      BULB_COLORS.pureWhite,
    ],
    patternRepeat: 1,
  },
  {
    id: 'redwarm',
    label: 'Red and warm white',
    colors: [BULB_COLORS.red, BULB_COLORS.warmWhite],
    patternRepeat: 2,
  },
  {
    id: 'redgreen',
    label: 'Red and green',
    colors: [BULB_COLORS.red, BULB_COLORS.green],
    patternRepeat: 2,
  },
  {
    id: 'bluewhite',
    label: 'Blue and pure white',
    colors: [BULB_COLORS.blue, BULB_COLORS.pureWhite],
    patternRepeat: 2,
  },
]

export const PATTERN_REPEATS = [1, 2, 3, 4]

export const hexToNumber = (hex: string): number => parseInt(hex.replace('#', ''), 16)
